import styled from 'styled-components';

import { GeneralInfo } from 'components/general-info';

export const StyledDetails = styled(GeneralInfo)`
  padding: unset;
`;
